import React, { useState } from 'react';
import { Tag, Award, Send, Cake, Lock } from 'lucide-react';
import CuponsTab from './CuponsTab';
import FidelidadeTab from './FidelidadeTab';
import LembretesMarketingTab from './LembretesMarketingTab';
import AniversarioTab from './AniversarioTab';
import PaywallCard from '../components/PaywallCard';

const ABAS = [
  { id: 'cupons', label: 'Cupons', icon: <Tag size={16} />, descricao: 'Crie cupons de desconto pra aplicar direto no valor do serviço escolhido pelo cliente.' },
  { id: 'fidelidade', label: 'Fidelidade', icon: <Award size={16} />, descricao: 'Recompense clientes fiéis automaticamente após N agendamentos, via WhatsApp.' },
  { id: 'lembretes', label: 'Lembretes', icon: <Send size={16} />, descricao: 'Envie lembretes individuais ou em massa pra sua base de clientes.' },
  { id: 'aniversario', label: 'Aniversário', icon: <Cake size={16} />, descricao: 'Mensagem automática de aniversário enviada no dia certo, direto pelo WhatsApp.' },
];

const MarketingPage = ({ temAcesso }) => {
  const isPremiumPlus = temAcesso('marketing');
  const [activeTab, setActiveTab] = useState('cupons');

  const abaAtiva = ABAS.find(a => a.id === activeTab);

  const renderConteudo = () => {
    if (!isPremiumPlus) {
      return <PaywallCard titulo={abaAtiva.label} descricao={abaAtiva.descricao} plano="Premium" />;
    }
    switch (activeTab) {
      case 'cupons': return <CuponsTab />;
      case 'fidelidade': return <FidelidadeTab />;
      case 'lembretes': return <LembretesMarketingTab />;
      case 'aniversario': return <AniversarioTab />;
      default: return null;
    }
  };

  return (
    <div className="w-full max-w-[950px] mx-auto p-4 box-border overflow-x-hidden font-sans text-left">
      <div className="bg-[#F8F7FF] p-1.5 rounded-[20px] flex flex-wrap gap-1.5 mb-8 w-full box-border border border-purple-50">
        {ABAS.map(aba => (
          <button
            key={aba.id}
            className={`flex-1 min-w-[120px] justify-center py-3 px-4 border-none rounded-2xl cursor-pointer text-[10px] font-black uppercase tracking-wider transition-all duration-300 flex items-center gap-2 ${activeTab === aba.id ? 'bg-white text-[#6D28D9] shadow-sm' : 'bg-transparent text-slate-400'}`}
            onClick={() => setActiveTab(aba.id)}
          >
            {aba.icon} {aba.label}
            {!isPremiumPlus && <Lock size={11} className="opacity-70" />}
          </button>
        ))}
      </div>

      {renderConteudo()}
    </div>
  );
};

export default MarketingPage;
